import { createFilterOptions } from '@material-ui/lab';
const filter = createFilterOptions();

export const getOptionsMap = (options) =>
  options.reduce((optionsMap, option) => {
    const optionValue = option?.value || option;
    optionsMap[optionValue] = option?.label || option;
    return optionsMap;
  }, {});

export const getOptionSelected = (currentOption, option) => {
  const currentOptionValue = currentOption?.value || currentOption;
  const optionValue = option?.value || option;

  return (
    String(currentOptionValue).toLowerCase() ===
    String(optionValue).toLowerCase()
  );
};

export const filterOptions = (currentValues) => (options, params) => {
  const filtered = filter(options, params);

  const newValue = params.inputValue.trim();
  const isDuplicateCustomOption = currentValues?.includes(newValue);

  if (newValue !== '' && !isDuplicateCustomOption) {
    filtered.push({
      value: newValue,
      label: `Add "${newValue}"`,
    });
  }
  return filtered;
};
